<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right list">
      <!-- <div class="searchbox">
			<form action="#" method="get" class="form-inline form-float">
               
								<div class='form-group others'> -->
      <!-- <span class='search_btn'><button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button></span>
                
                						<span class='add_btn'><button  type="button" class="btn btn-default" id="addarea" @click="addrOrEdit()">添加</button></span> -->

      <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
      <!-- </div>
               
			</form>
		</div> -->

      <el-table
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        :data="tableData"
        height="100%"
        row-key="id"
        default-expand-all
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="名称"
          sortable
          width="300"
        >
          <template slot-scope="scope">
            <span class="name-tip" v-if="scope.row.type == 'area'">区域</span>
            <span class="name-tip" v-if="scope.row.type == 'box'">岗亭</span>
            <span class="name-tip" v-if="scope.row.type == 'channel'"
              >通道</span
            >
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="person"
          label="联系人"
          sortable
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="phone" label="联系电话">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="totalNum" label="总车位">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="leftNum" label="剩余车位">
        </el-table-column>

        <el-table-column show-overflow-tooltip label="操作" width="150px">
          <template slot-scope="scope">
            <!-- <button class="edit operate-button"   type="button"  @click="addrOrEdit(scope.row.type,'',scope.row.parentId)">添加</button>
					<button class="edit operate-button"  type="button"  @click="addrOrEdit(scope.row.type,scope.row.id,scope.row.parentId)">修改</button>
                    <button class="delete operate-button"  @click="del(id)" type="button">删除</button> -->
            <button
              v-show="scope.row.ioState == '1'"
              class="code-download operate-button"
              @click="
                codeDownload(
                  scope.row.id,
                  scope.row.name,
                  codeDownloadData.enterCodeUrl
                )
              "
              type="button"
            >
              入口二维码
            </button>
            <button
              v-show="scope.row.ioState == '2'"
              class="code-download operate-button"
              @click="
                codeDownload(
                  scope.row.id,
                  scope.row.name,
                  codeDownloadData.exitCodeUrl
                )
              "
              type="button"
            >
              出口二维码
            </button>
            <button
              v-show="scope.row.type == 'channel'"
              class=" operate-button"
              @click="remoteOpen(scope.row)"
              type="button"
            >
              远程开闸
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加修改 -->
    <!-- <el-dialog title="添加修改" :visible.sync="dialogFormVisible" width="25%" :lock-scroll=false>
			
				<el-form class="fl"  ref="form" label-position="right" :model="formData"   id="form">
			    	<el-form-item label="名称" prop="">
			    		<el-col :span="18">
			      			<el-input v-model.trim="formData.name">
							</el-input>
			      		</el-col>
			      	</el-form-item>
					<el-form-item label="联系人" prop="">
			    		<el-col :span="18">
			      			<el-input v-model.trim="formData.person">
							</el-input>
			      		</el-col>
			      	</el-form-item>
					<el-form-item label="联系电话" prop="">
			    		<el-col :span="18">
			      			<el-input v-model.trim="formData.phone">
							</el-input>
			      		</el-col>
			      	</el-form-item>
				</el-form>
		  	<div slot="footer" class="dialog-footer">
		    	<el-button @click="dialogFormVisible = false">取 消</el-button>
		    	<el-button type="primary" @click="addrOrEditTrue">确 定</el-button>
		  	</div>
		</el-dialog> -->
    <!--选择巡检员-->
    <el-dialog
      title="选择巡检员"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="outerCodeDialogVisible"
    >
      <el-radio-group
        v-model="codeDownloadData.chargeUserId"
        @change="selectedChargerUser"
      >
        <el-radio
          v-for="item in allChargeUserData"
          :label="item.id"
          :key="item.id"
          >{{ item.username }}</el-radio
        >
      </el-radio-group>
    </el-dialog>
    <!--下载二维码-->
    <el-dialog
      title="下载二维码"
      :visible.sync="codeDialogVisible"
      :lock-scroll="false"
    >
      <table class="table">
        <thead>
          <tr>
            <td>二维码边长(cm)</td>
            <td>建议扫描距离(米)</td>
            <td>下载链接</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>8cm</td>
            <td>0.5m</td>
            <td @click="downloadQrcode(258, 258)">
              <button class="code-download">下载</button>
            </td>
          </tr>
          <tr>
            <td>15cm</td>
            <td>1m</td>
            <td @click="downloadQrcode(430, 430)">
              <button class="code-download">下载</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div id="qrcode"></div>
    </el-dialog>
  </div>
</template>
<script>
import AreaTree from "../../commons/parking/commons/areaTree.vue";
import {
  chargeUserList,
  addOrEditParking,
  getAllByParking,
  getRemoteOpen,
} from "@/api/url";
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  data() {
    return {
      codeDialogVisible: false,
      outerCodeDialogVisible: false,
      treeData: {
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableData: [
        // {
        // 	id: "05b89479135d4374b07bf8ad18c5836a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域3"
        // },
        // {
        // 	id: "0638f69b974f4a9daeb16af956a6fa6a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域5"
        // },
        // {
        // 	id: "05b89479135d4374b07bf8ad18c5836a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域3"
        // },
        // {
        // 	id: "0638f69b974f4a9daeb16af956a6fa6a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域5"
        // },
        // {
        // 	id: "685a841d9ca14028955be194abad5bec",
        // 	parentId: "-1",
        // 	"type": "area",
        // 	"children": [],
        // 	"name": "家德区域6"
        // },
        // {
        // 	id: "05b89479135d4374b07bf8ad18c5836a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域3"
        // },
        // {
        // 	id: "0638f69b974f4a9daeb16af956a6fa6a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域5"
        // },
        // {
        // 	id: "685a841d9ca14028955be194abad5bec",
        // 	parentId: "-1",
        // 	"type": "area",
        // 	"children": [],
        // 	"name": "家德区域6"
        // },
        // {
        // 	id: "05b89479135d4374b07bf8ad18c5836a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域3"
        // },
        // {
        // 	id: "0638f69b974f4a9daeb16af956a6fa6a",
        // 	parentId: "-1",
        // 	type: "area",
        // 	children: [],
        // 	name: "家德区域5"
        // },
        // {
        // 	id: "685a841d9ca14028955be194abad5bec",
        // 	parentId: "-1",
        // 	"type": "area",
        // 	"children": [],
        // 	"name": "家德区域6"
        // },
        // {
        // 	"id": "87d441ec768142448481e75ba375cf05",
        // 	"parentId": "-1",
        // 	"type": "area",
        // 	"children": [],
        // 	"name": "家德区域2"
        // },
        // {
        // 	"id": "cd0ea16b76904c2d83a02520aa20f075",
        // 	"parentId": "-1",
        // 	"type": "area",
        // 	"children": [
        // 		{
        // 			"id": "2abfde69710d4702b9efae8b788f61dc",
        // 			"parentId": "cd0ea16b76904c2d83a02520aa20f075",
        // 			"type": "box",
        // 			"children": [
        // 				{
        // 					"id": "9c5eff67823849f6975d7e6242cc53db",
        // 					"parentId": "2abfde69710d4702b9efae8b788f61dc",
        // 					"type": "channel",
        // 					"children": [],
        // 					"name": "家德通道",
        // 					"ioState": "1"
        // 				}
        // 			],
        // 			"name": "家德岗亭"
        // 		}
        // 	],
        // 	"name": "家德区域"
        // },
        // {
        // 	"id": "e87dc308d19a4cf6bdc0019fbf8aa323",
        // 	"parentId": "-1",
        // 	"type": "area",
        // 	"children": [],
        // 	"name": "家德区域4"
        // }
      ],
      allChargeUserData: [],
      codeDownloadData: {
        channelId: "",
        channelName: "",
        downloadUrl: "",
        chargeUserId: "",
        // enterCodeUrl:'http://wo100.natapp1.cc/pay/passagewayQRCode/enterQRCode',
        // exitCodeUrl:'http://wo100.natapp1.cc/pay/passagewayQRCode/channel'
        // enterCodeUrl:'http://bosk88.natapp1.cc/pay/passagewayQRCode/enterQRCode',
        // exitCodeUrl:'http://bosk88.natapp1.cc/pay/passagewayQRCode/channel'
        enterCodeUrl: "",
        exitCodeUrl: "",
      },
      dialogFormVisible: false,
      formData: {
        id: "",
        parkingId: "",
        parentId: "",
        name: "",
        person: "",
        phone: "",
        type: "",
        areaType: "",
      },
    };
  },
  methods: {
    tableList() {
      this.$get(getAllByParking(), { parkingId: this.treeData.parkingId }).then(
        (data) => {
          this.tableData = data;
        }
      );
    },
    handleTreeClick: function(node, data) {
      // console.log(node)
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.tableList();
      } else {
        this.treeData.parkingId = "";
        this.tableData = [];
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择车场'
        // })
        return;
      }
    },
    qrcode(id, chargeId, w, h, url) {
      let qrcode = new QRCode("qrcode", {
        width: w,
        height: h,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(`${url}?channelId=${id}&chargeId=${chargeId}`); //生成另一个新的二维码
    },
    downloadQrcode(w, h) {
      document.getElementById("qrcode").innerHTML = "";
      var id = this.codeDownloadData.channelId;
      var name = this.codeDownloadData.channelName;
      var url = this.codeDownloadData.downloadUrl;
      var chargeUser = this.codeDownloadData.chargeUserId;
      this.qrcode(id, chargeUser, w, h, url);

      setTimeout(function() {
        var qrcode = document.getElementById("qrcode");
        var img = qrcode.getElementsByTagName("img")[0];
        var link = document.createElement("a");
        var url = img.getAttribute("src");

        link.setAttribute("href", url);
        link.setAttribute("download", `${name}(${w}).png`);
        //         link.click();
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }, 1);
    },
    codeDownload(id, name, url) {
      this.codeDownloadData.chargeUserId = "";
      this.getAllChargeUsers();
      this.outerCodeDialogVisible = true;
      this.codeDownloadData.channelId = id;
      this.codeDownloadData.channelName = name;
      this.codeDownloadData.downloadUrl = url;
    },
    getAllChargeUsers: function() {
      var _this = this;
      this.$get(chargeUserList() + "?isDeleted=0", {
        limit: 0,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);

        _this.allChargeUserData = data.data.rows;
        console.log(_this.allChargeUserData);
        // _this.tableListData=data.data;
      });
    },
    selectedChargerUser() {
      this.outerCodeDialogVisible = false;
      this.codeDialogVisible = true;
    },
    remoteOpen(channel) {
      const { id } = channel;
      this.$confirm("是否继续远程开闸?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          this.$get(
            `${getRemoteOpen()}?parkingId=${
              this.treeData.parkingId
            }&channelId=${id}`
          ).then((data) => {
            if (data?.status ===200) {
              this.$message({
                type: "success",
                message: "开闸成功!",
              });
            } else {
              this.$message({
                type: "warning",
                message: "开闸失败!",
              });
            }
          });
        })
        .catch(() => {
         
        });
    },
  },
  components: {
    AreaTree,
  },
  mounted() {
    this.codeDownloadData.enterCodeUrl = `${this.$codeUrl}/pay/passagewayQRCode/enterQRCode`;
    this.codeDownloadData.exitCodeUrl = `${this.$codeUrl}/pay/passagewayQRCode/channel`;
  },
};
</script>
<style scoped>
.list {
  padding-bottom: 0 !important;
  overflow: hidden !important;
}
#qrcode {
  display: none;
}
</style>
<style>
.name-tip {
  color: red;
  font-size: 10px;
}
.el-table [class*="el-table__row--level"] .el-table__expand-icon {
  margin-left: -24px;
}
.el-table__placeholder {
  width: 0;
}

/* .el-table__row td:first-child {
	text-align:left!important;
	display:flex;
	justify-content: center;
	
} */
/* .el-table__row td:first-child .cell{
	width:250px;
	padding-left:30px!important;
} */
</style>
